import { AssistantChatMessageFeedback, AssistantChatMessageRating } from 'lib/apiClient'

export function createTempAssistantChatMessageFeeback(
  id: string,
  rating: AssistantChatMessageRating,
): AssistantChatMessageFeedback {
  return {
    assistantGenerationId: id,
    feedbackId: id,
    rating,
    feedback: null,
    reasons: null,
    createdDate: new Date().toISOString(),
    updatedDate: new Date().toISOString(),
    author: '',
  }
}
